// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2lG1w","header":"PatientQuestionnaire_header__nPnIw","info":"PatientQuestionnaire_info__3qEiQ"};